import VueFormInfo from '@ui-common/vue-form-info';
import VueProgress from '@ui-common/vue-progress';
import { mapState, mapActions } from 'vuex';
import personalLoanCalculatorKo2021Form from './personal-loan-calculator-ko-2021-form/personal-loan-calculator-ko-2021-form.vue';
import personalLoanCalculatorKo2021Result from './personal-loan-calculator-ko-2021-result/personal-loan-calculator-ko-2021-result.vue';

export default {
	data() {
		return {
			isCallRequestFeedback: false
		};
	},
	props: {
		results: { required: true },
		showKoForm: { required: true },
		successProductId: { required: true },
		successQuestionId: { required: true },
		failedProductId: { required: true },
		failedQuestionId: { required: true },
		noKoProductId: { required: true },
		noKoQuestionId: { required: true },
		uuid: { required: true },
		higherIncome: { required: true },
		successOrErrorOrLoading: { required: true },
		formal: { required: true }
	},
	watch: {
		secondStep(val) {
			if (val && this.isMobile) {
				this.$nextTick(() => {
					this.$scrollTo(this.$el, { duration: 500, container: '#personal_loan_ko_modal' });
				});
			}
		}
	},
	components: {
		VueFormInfo,
		VueProgress,
		'personal-loan-calculator-ko-2021-form': personalLoanCalculatorKo2021Form,
		'personal-loan-calculator-ko-2021-result': personalLoanCalculatorKo2021Result
	},
	computed: {
		...mapState('personalLoanCalculatorKo2021', ['technicalError', 'loading', 'firstStep', 'secondStep', 'koFormData', 'koCalculationResponse']),
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		showVhk() {
			return (this.secondStep && this.koCalculationResponse) || !this.showKoForm;
		},
		steps() {
			return [
				{
					text: '',
					current: this.firstStep,
					done: this.secondStep
				},
				{
					text: '',
					current: this.secondStep
				}
			];
		},
		formalString() {
			return this.formal.toString();
		}
	},
	methods: {
		...mapActions('personalLoanCalculatorKo2021', ['calculate', 'getKoForm', 'resetKoForm', 'setUuid'])
	},
	mounted() {
		this.getKoForm();
		this.setUuid(this.uuid);
		this.$modalEventBus.$on('modal-opened', (modalId) => {
			if (modalId == 'personal_loan_ko_modal') {
				if (this.showKoForm) {
					this.resetKoForm();
				}
			}
		});
		if (this.showKoForm) {
			window.addEventListener('call-request-state-change', ({ detail }) => {
				if (detail.id == 'personal_loan_ko_modal' && detail.state == 'FORM' && this.koCalculationResponse) {
					const payLoadEvent = new CustomEvent('call-request-plo-set-payload', { detail: this.koCalculationResponse });
					window.dispatchEvent(payLoadEvent);
				}
			});
		}
	}
};
